import {
  AfterViewInit, Component, ElementRef, EventEmitter, Input,
  OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren
} from '@angular/core';
import { CbjGalleryItemComponent } from './cbj-gallery-item.component';
export class CbjGalleryComponent implements OnInit, AfterViewInit, OnDestroy {
/**
 * The galleries height
 * 
 */
height: string;
/**
 * The galleries width
 * 
 */
width: string;
/**
 * The columns width in pixels
 * 
 */
colWidth: number;
/**
 * The width of the space between cols
 * 
 */
gutterWidth: number;
/**
 * An array of image links
 * 
 */
images: string[];
/**
 * An array of classes to add to the img tags
 * 
 */
classes: string[] = [];
/**
 * The generated gallery items
 * 
 */
items = new QueryList<CbjGalleryItemComponent>();
/**
 * The click event emitter for broadcasting the click events on the images
 * 
 */
imgClick: EventEmitter<{ i: CbjGalleryItemComponent, e: Event }>;
/**
 * The element wrapping all the items
 * 
 */
wrapper: ElementRef;
/**
 * An array of heights of each column
 * 
 */
private colHeights: number[] = [];
/**
 * The number of columns in a row
 * 
 */
private colsPerRow: number;
/**
 * The column currently being inserted into
 * 
 */
private curCol: number;
/**
 * The row currently adding columns to
 * 
 */
private curRow: number;
/**
 * OnInit
 * Setup the EventEmitter
 * @return {?}
 */
ngOnInit() {
    this.imgClick = new EventEmitter<{ i: CbjGalleryItemComponent, e: Event }>();
  }
/**
 * AfterViewInit
 * Wait a tick to make sure all values are set
 * Make our measurement to calc how many cols per row
 * Position the items
 * @return {?}
 */
ngAfterViewInit() {
    setTimeout(() => {
      this.gutterWidth = this.gutterWidth ? this.gutterWidth : 30;
      this.colsPerRow = this.colWidth <= 1 ?
        Math.floor(this.colWidth * this.wrapper.nativeElement.clientWidth) :
        Math.round(this.wrapper.nativeElement.clientWidth / (this.colWidth + this.gutterWidth)) - 1;
      this.curCol = 0;
      this.curRow = 0;
      setTimeout(() => {
        this.createLayout();
      }, 150);
      this.items.changes.subscribe(this.addToLayout);
    }, 150);
  }
/**
 * OnDestroy
 * Cleanup the emitter
 * @return {?}
 */
ngOnDestroy() {
    this.imgClick.next(null);
    this.imgClick.complete();
  }
/**
 * Emit our click event
 * 
 */
emitClick = (arg: { i: CbjGalleryItemComponent, e: Event }) => {
    this.imgClick.next({ i: arg.i, e: arg.e });
  }
/**
 * Use to add items to the gallery after creation
 * 
 * @param {?} images
 * @return {?}
 */
addItems(images: string[]) {
    for (const /** @type {?} */ image of images) {
      this.images.push(image);
    }
  }
/**
 * Position the items in the gallery AfterViewInit
 * 
 * @return {?}
 */
private createLayout() {
    this.items.toArray().forEach((it: CbjGalleryItemComponent) => {
      this.setItemDims(it);
    });
    for (let /** @type {?} */ i = 0; i < this.items.length; i++) {
      const /** @type {?} */ insert = this.items.filter(item => item.column === undefined)[0];
      this.positionItem(insert);
    }
  }
/**
 * Add items to an existing gallery
 */
private addToLayout = () => {
    this.items
      .filter(item => item.id === undefined)
      .forEach((item: CbjGalleryItemComponent) => {
        if (item.el.nativeElement.firstChild.naturalHeight === 0) {
          setTimeout(() => {
            this.setItemDims(item);
            this.positionItem(item);
          }, 150);
        } else {
          this.setItemDims(item);
          this.positionItem(item);
        }
      });
  }
/**
 * Calculate and set the items dimensions
 * 
 * @param {?} it
 * @return {?}
 */
private setItemDims(it: CbjGalleryItemComponent) {
    const /** @type {?} */ w = (this.colWidth - this.gutterWidth);
    it.width = w + 'px';
    it.height = Math.round(w * this.getRatio(it.el)) + 'px';
    it.state = 'sized';
  }
/**
 * Calculates aspect-ratio
 * 
 * 
 * @param {?} el
 * @return {?}
 */
private getRatio(el: ElementRef) {
    const /** @type {?} */ img = el.nativeElement.firstChild;
    return img.naturalHeight / img.naturalWidth;
  }
/**
 * Positions an individual item
 * 
 * @param {?} it
 * @return {?}
 */
private positionItem(it: CbjGalleryItemComponent) {
    it.left = this.findLeft();
    it.top = this.findTop(it);
    it.column = this.curCol;
    it.id = this.curCol + (this.colsPerRow * this.curRow);
    this.incrementColRow();
    // wait a tick before toggling state so animations runs properly
    setTimeout(() => it.state = 'positioned', 0);
  }
/**
 * Calculates the left property for an item
 * 
 * @return {?}
 */
private findLeft() {
    let /** @type {?} */ left: string;

    if  (this.curCol === 0) {
      left = this.gutterWidth / 2 + 'px';
    }else {
      const /** @type {?} */ padCols = (this.colWidth * this.curCol) + (this.curCol * this.gutterWidth);
      left = padCols + 'px';
    }

    return  left;
  }
/**
 * Calculates the top position of an item
 * 
 * 
 * @param {?} it
 * @return {?}
 */
private findTop(it: CbjGalleryItemComponent) {
    let /** @type {?} */ top = this.gutterWidth / 2;

    if (typeof this.colHeights[this.curCol] === 'undefined') {
      console.log(it.height);
      this.colHeights[this.curCol] = parseInt(it.height, 10) + this.gutterWidth;
    } else {
      top += this.colHeights[this.curCol];
      this.colHeights[this.curCol] += parseInt(it.height, 10) + this.gutterWidth;
    }

    return top + 'px';
  }
/**
 * Increments curCol or sets to 0 if on last column in row
 * Increments row number if at last col
 * @return {?}
 */
private incrementColRow() {
    if (this.curCol >= this.colsPerRow) {
      this.curCol = 0;
      this.curRow++;
    }else {
     this.curCol++;
    }
  }
/**
 * @param {?} start
 * @return {?}
 */
private rePosition(start: number) {
    this.curCol = start;
    this.items
      .filter(item => item.column >= start)
      .forEach((it: CbjGalleryItemComponent) => {
        this.positionItem(it);
      });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-gallery',
  template: `
    <div #wrapper class="position-relative" [style.height]="height" [style.width]="width" [style.overflow]="'hidden'">
        <cbj-gallery-item *ngFor="let image of images" [clickE]="emitClick" [classes]="classes" [src]="image"></cbj-gallery-item>
    </div>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'height': [{ type: Input, args: ['height', ] },],
'width': [{ type: Input, args: ['width', ] },],
'colWidth': [{ type: Input, args: ['colWidth', ] },],
'gutterWidth': [{ type: Input, args: ['gutterWidth', ] },],
'images': [{ type: Input, args: ['images', ] },],
'classes': [{ type: Input, args: ['classes', ] },],
'items': [{ type: ViewChildren, args: [CbjGalleryItemComponent, ] },],
'imgClick': [{ type: Output, args: ['imgClick', ] },],
'wrapper': [{ type: ViewChild, args: ['wrapper', ] },],
};
}

function CbjGalleryComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjGalleryComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjGalleryComponent.ctorParameters;
/** @type {?} */
CbjGalleryComponent.propDecorators;
/**
 * The galleries height
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.height;
/**
 * The galleries width
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.width;
/**
 * The columns width in pixels
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.colWidth;
/**
 * The width of the space between cols
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.gutterWidth;
/**
 * An array of image links
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.images;
/**
 * An array of classes to add to the img tags
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.classes;
/**
 * The generated gallery items
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.items;
/**
 * The click event emitter for broadcasting the click events on the images
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.imgClick;
/**
 * The element wrapping all the items
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.wrapper;
/**
 * An array of heights of each column
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.colHeights;
/**
 * The number of columns in a row
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.colsPerRow;
/**
 * The column currently being inserted into
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.curCol;
/**
 * The row currently adding columns to
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.curRow;
/**
 * Emit our click event
 * 
 * @type {?}
 */
CbjGalleryComponent.prototype.emitClick;
/**
 * Add items to an existing gallery
 * @type {?}
 */
CbjGalleryComponent.prototype.addToLayout;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
